import { ref } from "vue";

import store from "../state/store"


export default function useSellerProducts() {

    const productStatus = ref("")
    const search = ref("")
    const perPage = ref(10)
    const sortField = ref("updated_at")
    const sortDirection = ref("desc")
    const loading = ref(false)


    const storeGetProducts = (url = null) => {
        store.dispatch("storeGetProducts", {
            url,
            search: search.value,
            status: productStatus.value,
            per_page: perPage.value,
            sort_field: sortField.value,
            sort_direction: sortDirection.value,
        })
    }




    return {
        productStatus,
        search,
        perPage,
        loading,
        storeGetProducts,
    }
}